<template lang="pug">
md-layout(md-column)
  // Confirm dialog
  md-theme(md-name='blue')
    md-dialog(:md-click-outside-to-close='false', ref='confirmLeave')
      md-dialog-title Please confirm
      md-dialog-content
        p You are just about to leave this page and your video will be
          strong  discarded.
      md-dialog-actions
        md-button.md-primary(@click.native='leaveThePage') Confirm
        md-button(@click.native='$refs.confirmLeave.close()') Cancel
  // Page loader
  md-progress.md-accent(md-indeterminate, v-show='loadingComponent')
  // Page content
  md-theme(md-name='blue', v-show='!loadingComponent')
    // Title
    breadcrumbs#scrollToError(section='Videos', :nav='nav')
    // Form
    md-layout.form-wrapper(:md-gutter='16')
      md-layout(md-flex='100', v-if='!editMode')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          video-uploader(@uploadSuccess='onUploadSuccess', @uploadFailed='onUploadFailure', @uploadCancel='onUploadCancel', @videoUploading='onVideoUploading', @videoName='onVideoName',  @videoDuration='onVideoDuration', :form-submitted='formSubmitted', :validations='$v')
          subtitle-uploader(@subtitle-uploaded='onSubtitleUploaded', @delete-subtitle='deleteSubtitle', :subtitlesProp='mediaItem.subtitles')
      md-layout(md-flex='100', v-if='editMode')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          media-item-preview(:media-item='mediaItem',  @videoDuration='onVideoDuration')
          subtitle-uploader(@subtitle-uploaded='onSubtitleUploaded', @delete-subtitle='deleteSubtitle', :subtitlesProp='mediaItem.subtitles', :isEditMode='editMode')
      md-layout(md-flex='100', v-if='editMode && mediaItem.poster && mediaItem.thumbnails')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          poster-selector(:media-item='mediaItem', @update='updatePoster' @deleteCustom='deleteCustomThumbnail')
          md-layout(md-flex='100')
      md-layout(md-flex='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          .md-headline Images
            p.errorMessage(v-if='noImagesLive') If status is "live" the images are required
            image-upload-croped(:accountID='accountID', @uploadSuccessPoster='onUploadCustomImageSuccess', @uploadSuccessHero='onHeroImageUploadSuccess', @uploadSuccessPortrait='onUploadPortraitSuccess', :media-item="mediaItem", :is-media-item="true")
      md-layout(md-flex='50', md-flex-small='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          metadata-form(title='Video', :entity='mediaItem', :form-submitted='formSubmitted', :validations='$v.mediaItem')
          status-radio(v-model='mediaItem.status', v-on:input="statusChanged($event)")
          div.container-info(v-if='mediaItem.status === "public" || mediaItem.publicationDate.date')
            md-icon.icon-info(md-iconset="fa fa-info")
            p.check-properties() Please, check video properties if you want this video in the Marketplace.

      md-layout(md-flex='50', md-flex-small='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          content-targets-form(:entity='mediaItem', @created='showAlertToast($event, "success")', @error='showAlertToast($event, "error")', :form-submitted='formSubmitted', :validations='mediaItem')
          playlist-selector(:multiple="true", @input="selectedPlaylist", :value="mediaItem.playlists")
          rental-pricing-form(@price-selected="handlePriceSelected" :price="getPriceAmount(mediaItem.prices)")
          date-input-time(v-show='mediaItem.status === "draft"', :publicationDate='mediaItem.publicationDate', @publicationDateEmit='publicationDateEmitter', label='Release Date', :formSubmitted="formSubmitted", :validation='$v.mediaItem.publicationDate', :status='mediaItem.status')
      md-layout(md-flex='50', md-flex-small='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          language-form(:entity='mediaItem')
      md-layout(md-flex='50', md-flex-small='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          properties-form(:entity='mediaItem', @created='showAlertToast($event, "success")', @error='showAlertToast($event, "error")', :form-submitted='formSubmitted', :validations='$v.mediaItem')
      //- Series
      md-layout(md-flex='50', md-flex-small='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          content-serie-form(:entity='mediaItem', :form-submitted='formSubmitted', :episode-number-error='episodeNumberError', :season-number-error='seasonNumberError', @isMiniSerie='isMiniSerieFunction')
      
      //- Credits
      md-layout( md-flex='50', md-flex-small='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          credits-form(:entity='mediaItem', title='Credits')
      //- Roku Ad Breaks
      md-layout( md-flex='100', md-flex-small='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          .md-headline Ad Breaks
          p(v-if='mediaItem.videoDuration === 0') You must select a video to have the adbreaks options.
          div(v-else)
            p(v-if='mediaItem.videoDuration < 420') This video cannot have ad breaks because it is less than 7 minutes long. It will only have a pre-roll.
            media-item-roku-ad-breaks(v-else, :mediaItem='mediaItem', :form-submitted='formSubmitted')
      md-layout.disclaimer-check(md-align='center', md-flex='50', md-flex-offset='25', v-show='!editMode')
        .md-caption I own and/or have the right to distribute this content across domains, geographic regions, platforms, and windows of time specified in accordance with the associated licenses attached to this content or perpetually, and without restriction in the absence of attached licenses.
        md-checkbox.md-primary.md-body-2(v-model='mediaItem.accountHasRights') I own or can distribute this content.
      md-layout(md-align='center', md-flex='100')
        stitch-loader(:loading='creatingOrUpdating', :size='40')
        md-button#submit-btn.md-raised.md-primary(@click='onFormSubmit', v-show='!creatingOrUpdating', :disabled='$v.$pending || !mediaItem.accountHasRights')
          | {{ editMode ? 'Update' : 'Create' }}
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { isValidDateTime } from "../../services/validatorService";
import mediaItemService from "../../services/mediaItemService";
import StitchLoader from "../../shared-components/Loader";
import MetadataForm from "../../shared-components/forms/MetadataForm";
import StatusRadio from "../../shared-components/StatusRadio";
import DemographicForm from "../../shared-components/forms/DemographicForm";
import PropertiesForm from "../../shared-components/forms/PropertiesForm";
import ContentTargetsForm from "../../shared-components/forms/ContentTargetsForm";
import CreditsForm from "../../shared-components/forms/CreditsForm";
import MediaItemPreview from "../../shared-components/mediaItem/MediaItemPreview";
import PosterSelector from "../../shared-components/mediaItem/MediaItemPosterSelector";
import VideoUploader from "../../shared-components/upload/VideoUploader";
import Breadcrumbs from "../../shared-components/Breadcrumbs";
import ContentSerieForm from "../../shared-components/forms/ContentSerieForm";
import MediaItemRokuAdBreaks from "../../shared-components/mediaItem/MediaItemsRokuAdBreaks.vue";
import HeroImageUploader from "../../shared-components/upload/HeroImageUploader.vue";
import ThumbnailUploader from "../../shared-components/mediaItem/ThumbnailUploader.vue";
import ImageUploadCroped from "../../shared-components/upload/ImageUploadCroped.vue";
import PlaylistSelector from "../../shared-components/playlist/PlaylistSelector.vue";
import RentalPricingForm from "../../shared-components/forms/RentalPricingForm.vue";
import SubtitleUploader from "../../shared-components/upload/SubtitleUploader.vue";
import DateInputTime from "../../shared-components/forms/DateInputTime.vue";
import LanguageForm from "../../shared-components/forms/LanguageForm.vue";

export default {
  mixins: [validationMixin],
  components: {
    MetadataForm,
    StitchLoader,
    mediaItemService,
    StatusRadio,
    DemographicForm,
    PropertiesForm,
    ContentTargetsForm,
    CreditsForm,
    MediaItemPreview,
    PosterSelector,
    VideoUploader,
    Breadcrumbs,
    ContentSerieForm,
    MediaItemRokuAdBreaks,
    HeroImageUploader,
    ThumbnailUploader,
    ImageUploadCroped,
    PlaylistSelector,
    RentalPricingForm,
    SubtitleUploader,
    DateInputTime,
    LanguageForm,
  },
  computed: {
    ...mapState({
      siteuser: (state) => state.user.siteuser,
      accountID: (state) => state.user.siteuser.user_metadata.account_id,
    }),
    nav() {
      return [
        { title: "Videos", route: "Videos" },
        { title: this.editMode ? "Edit Video" : "New Video" },
      ];
    },

    editMode() {
      return !!this.$route.params.id;
    },
  },
  data() {
    return {
      loadingComponent: false,
      creatingOrUpdating: false,
      mediaItemCreated: false,
      mediaItemOriginalName: null,
      formSubmitted: false,
      fileUploaded: false,
      noImagesLive: false,
      mediaItem: {
        name: "",
        shortDescription: "",
        description: "",
        language: "",
        status: "draft",
        tags: [],
        prices: [],
        subtitles:[],
        ingestType: "upload",
        sourceMaster: {
          type: "",
          url: "",
        },
        encodeMaster: {
          type: "",
          url: "",
        },
        licenses: [],
        poster: {
          desktop: '',
          default: '',
          mobile: '',
          tablet: '',
        },
        publicationDate:{
          date: null,
          timeZone: null
        },
        pathImageDefault: 'defaultImages/default-rhebus-16x9.jpeg',
        customThumbnail: "",
        heroImage: "",
        thumbnail2x3: "",
        includeInMarketplace: false,
        categories: [],
        playlists:[],
        demographic: {
          gender: null,
          households: [],
          incomes: [],
          ages: [],
          educations: [],
        },
        renditions: {},
        accountHasRights: false,
        serie: null,
        episodeNumber: null,
        seasonNumber: null,
        videoUploadCompleted: false,
        videoName: "",
        typeOfRokuVideo: "",
        typeOfRokuVideoAdBreaks: "autoPreRoll",
        rokuOptimizedVideoAdBreaks: [],
        rokuCustomVideoAdBreaks: [],
        videoDuration: 0,
        uploadedBy: JSON.parse(localStorage.getItem("profile")).user_email,
      },
      toRoute: null,
      leaveConfirmed: false,
      isMiniSerie: false,
      episodeNumberError: false,
      seasonNumberError: false,
    };
  },
  validations: {
    fileUploaded: {
      required(value) {
        return this.editMode || value;
      },
    },
    mediaItem: {
      name: {
        required,
        async isUnique(value) {
          const hasToCheck =
            !this.editMode || value !== this.mediaItemOriginalName;
          if (value && hasToCheck) {
            const response = await mediaItemService.getList({
              exactName: value,
              limit: 1,
            });
            return response.data.total === 0;
          } else {
            return true;
          }
        },
      },
      licenses: {
        required,
      },
      // network: {
      //   required,
      // },
      categories: {
        required,
      },
      shortDescription: {
        required,
      },
      description: {
        required,
      },
      heroImage: {
        validStatus(value){
          if(this.mediaItem.status !== 'public' && (value !== 'false' || !!value)){
            return true
          } else{
            return required(value)
          }
        },
      },
      publicationDate: {
        validDate(value) {
          if (!value || !value.date) return true;
          const datePart = value.date.slice(0, 16);
          return isValidDateTime(datePart);
        },
        isFutureDate(value) {
          if (!value || !value.date) return true;
          const nowUTC = new Date();
          nowUTC.setMinutes(nowUTC.getMinutes() - nowUTC.getTimezoneOffset());
          const selectedDateTime = new Date(value.date);
          return selectedDateTime > nowUTC;
        }
      }
    },
  },
  methods: {
    getPriceAmount(prices) {
      if (Array.isArray(prices) && prices.length > 0) {
        const firstPrice = prices[0];
        return firstPrice.price ? firstPrice.price.amount : null;
      }
      return null;
    },

    selectedPlaylist(playlist) {
      this.mediaItem.playlists = playlist;
    },
    showAlertToast(text, icon) {
      this.$swal({
        text: text,
        position: "bottom-left",
        icon: icon,
        toast: true,
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
    },

    handlePriceSelected(option) {
        if(option) {
            this.mediaItem.prices[0] = option
        }
      },

    onSubtitleUploaded({language, path}) {
      this.mediaItem.subtitles = [{
        language,
        path,
      }];
    },
    deleteSubtitle() {
      this.mediaItem.subtitles = [];
    },

    statusChanged(value) {
      if (value !== "public") this.mediaItem.includeInMarketplace = false;
    },

    publicationDateEmitter(value) {
      this.mediaItem.publicationDate = value;
    },

    isAdmin() {
      // Check user has 'authorization' and Check user has 'roles'
      if (this.siteuser.authorization && this.siteuser.authorization.roles) {
        return this.siteuser.authorization.roles.includes("Admin");
      }

      return false;
    },
    createMediaItem() {
      if(this.mediaItem.poster.default === '') {
        this.mediaItem.poster.default = this.mediaItem.pathImageDefault
        this.mediaItem.poster.desktop = this.mediaItem.pathImageDefault
        this.mediaItem.poster.mobile = this.mediaItem.pathImageDefault
        this.mediaItem.poster.tablet = this.mediaItem.pathImageDefault
      }
      mediaItemService
        .create(this.filterMediaItem(this.mediaItem))
        .then(() => {
          this.showAlertToast("Video created successfully", "success");
          this.mediaItemCreated = true;
          this.$session.set("iWasInPage", 1);
          this.$delayedNavigation(this.$router, "Videos");
        })
        .catch(() => {
          this.showAlertToast(
            "Video could not be created. Please, try again later.",
            "error"
          );
        })
        .then(() => {
          this.creatingOrUpdating = false;
        });
    },
    updateMediaItem() {
      this.mediaItem.prices = this.mediaItem.prices.map(
        (value) => Number(value) || value.price.amount
      );
      mediaItemService
        .update(this.$route.params.id, this.mediaItem)
        .then(() => {
          this.showAlertToast("Video updated successfully", "success");
          this.$delayedNavigation(this.$router, "Videos");
        })
        .catch(() => {
          this.showAlertToast(
            "Video could not be updated. Please, try again later",
            "error"
          );
        })
        .then(() => {
          this.creatingOrUpdating = false;
        });
    },
    checkInvalidImages() {
      const isLiveOrHasPublicationDate =
        this.mediaItem.status === "public" ||
        this.mediaItem.publicationDate.date;

      return isLiveOrHasPublicationDate &&
        (this.mediaItem.heroImage === "false" ||
        this.mediaItem.heroImage === "" ||
        this.mediaItem.thumbnail2x3 === '');
    },
    updateImagePoster(){
      this.mediaItem.poster.default = this.mediaItem.customThumbnail
      this.mediaItem.poster.desktop = this.mediaItem.customThumbnail
      this.mediaItem.poster.mobile = this.mediaItem.customThumbnail
      this.mediaItem.poster.tablet = this.mediaItem.customThumbnail
    },
    onFormSubmit() {
      this.noImagesLive = false;
      this.creatingOrUpdating = true;
      this.formSubmitted = true;
      setTimeout(() => {
        this.checkMediaItemObject();
        if (
          !this.$v.$invalid &&
          !this.seasonNumberError &&
          !this.episodeNumberError
        ) {
          if (this.editMode) {
            if (this.checkInvalidImages()) {
              this.noImagesLive = true;
              const scrollToError = this.$el.querySelector("#scrollToError");
              scrollToError.scrollIntoView({ behavior: "smooth" });
              this.creatingOrUpdating = false;
            } else {
              if(this.mediaItem.customThumbnail !== '') this.updateImagePoster()
              this.noImagesLive = false;
              this.updateMediaItem();
            }
          } else {
            if(this.mediaItem.customThumbnail !== '') this.updateImagePoster()
            this.noImagesLive = false;
            this.createMediaItem();
          }
        } else {
          if(this.checkInvalidImages()) this.noImagesLive = true
          const scrollToError = this.$el.querySelector("#scrollToError");
          scrollToError.scrollIntoView({ behavior: "smooth" });
          this.creatingOrUpdating = false;
        }
      }, 800);
    },

    onHeroImageUploadSuccess({ url }) {
      this.mediaItem.heroImage = url;
    },
    onUploadCustomImageSuccess({url}) {
      this.mediaItem.customThumbnail = url;
    },
    onUploadPortraitSuccess({url}) {
      this.mediaItem.thumbnail2x3 = url;
    },

    onUploadFailure() {
      this.showAlertToast(
        "The video could not be uploaded. Please, try again later",
        "error"
      );
    },
    onUploadCancel() {
      this.showAlertToast("The video upload was canceled", "error");
    },
    onUploadSuccess({ url, mimeType }) {
      this.fileUploaded = true;
      this.mediaItem.sourceMaster = { type: mimeType, url };
      this.mediaItem.encodeMaster = { type: mimeType, url };
      this.mediaItem.videoUploadCompleted = true;
    },
    onVideoUploading(mimeType) {
      this.mediaItem.sourceMaster.type = mimeType;
      this.mediaItem.encodeMaster.type = mimeType;
      this.fileUploaded = true;
    },
    onVideoName(videoName) {
      this.mediaItem.videoName = videoName;
    },
    onVideoDuration(videoDuration) {
      if (videoDuration > 900) {
        this.mediaItem.typeOfRokuVideo = "longFormVideo";
      } else {
        this.mediaItem.typeOfRokuVideo = "shortFormVideo";
      }
      this.mediaItem.videoDuration = videoDuration;
    },
    leaveThePage() {
      this.leaveConfirmed = true;
      this.$refs.confirmLeave.close();
      const { name, path, params, query } = this.toRoute;
      if (name) {
        this.$router.push({ name, params, query });
      } else {
        this.$router.push({ path, params, query });
      }
    },
    filterMediaItem(mediaItem) {
      // Allow only properties that can be validated in BE
      const {
        name,
        shortDescription,
        description,
        language,
        status,
        tags,
        prices,
        ingestType,
        sourceMaster,
        encodeMaster,
        licenses,
        poster,
        customThumbnail,
        heroImage,
        thumbnail2x3,
        includeInMarketplace,
        categories,
        network,
        channels,
        playlists,
        demographic,
        accountHasRights,
        serie,
        episodeNumber,
        seasonNumber,
        videoUploadCompleted,
        videoName,
        typeOfRokuVideo,
        typeOfRokuVideoAdBreaks,
        rokuOptimizedVideoAdBreaks,
        rokuCustomVideoAdBreaks,
        videoDuration,
        uploadedBy,
        subtitles,
        publicationDate
      } = mediaItem;
      return {
        name,
        shortDescription,
        description,
        language,
        status,
        tags,
        prices,
        ingestType,
        sourceMaster,
        encodeMaster,
        licenses,
        poster,
        customThumbnail,
        heroImage,
        thumbnail2x3,
        includeInMarketplace,
        categories,
        network,
        channels,
        playlists,
        demographic,
        accountHasRights,
        serie,
        episodeNumber,
        seasonNumber,
        videoUploadCompleted,
        videoName,
        typeOfRokuVideo,
        typeOfRokuVideoAdBreaks,
        rokuOptimizedVideoAdBreaks,
        rokuCustomVideoAdBreaks,
        videoDuration,
        uploadedBy,
        subtitles,
        publicationDate
      };
    },
    updatePoster(poster) {
      this.mediaItem.poster = {
        desktop: poster,
        default: poster,
        mobile: poster,
        tablet: poster,
      };
      this.showAlertToast("Poster updated.", "success");
    },
    deleteCustomThumbnail() {
      this.mediaItem.customThumbnail = "";
    },
    isMiniSerieFunction(value) {
      this.isMiniSerie = value;
    },
    checkMediaItemObject() {
      const { episodeNumber, seasonNumber } = this.mediaItem;
      if (this.mediaItem.serie) {
        if (this.isMiniSerie) {
          this.mediaItem.seasonNumber = null;
        } else {
          if (!!seasonNumber) {
            this.mediaItem.seasonNumber = parseInt(seasonNumber);
            this.seasonNumberError = false;
          } else {
            this.seasonNumberError = true;
            return;
          }
        }

        if (!!episodeNumber) {
          this.mediaItem.episodeNumber = parseInt(episodeNumber);
          this.episodeNumberError = false;
        } else {
          this.episodeNumberError = true;
          return;
        }
        this.mediaItem.episodeNumber = !!episodeNumber
          ? parseInt(episodeNumber)
          : (this.episodeNumberError = true);
      } else{
        this.seasonNumberError = false;
        this.episodeNumberError = false;
      }
    },
  },
  mounted() {
    if (this.editMode) {
      this.loadingComponent = true;
      mediaItemService
        .get(this.$route.params.id)
        .then((response) => {
          this.mediaItem = {
            ...this.mediaItem,
            ...response.data.mediaItem,
            prices: response.data.mediaItem.prices.filter((value) =>
              Number.isInteger(value.price.amount)
            ),
          };
          this.mediaItem.seasonNumber === null
            ? this.mediaItem.episodeNumber !== null
              ? (this.isMiniSerie = true)
              : (this.isMiniSerie = false)
            : (this.isMiniSerie = false);
          this.mediaItemOriginalName = this.mediaItem.name;
        })
        .catch(() => {
          this.showAlertToast(
            "Video could not be retrieved. Please, try again later",
            "error"
          );
        })
        .then(() => {
          this.loadingComponent = false;
        });
    } else {
      this.mediaItem.tags = ['most popular'];
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.fileUploaded && !this.leaveConfirmed && !this.mediaItemCreated) {
      this.toRoute = to;
      this.$refs.confirmLeave.open();
      next(false);
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
.errorMessage{
  color: #ff5722;
  font-size: 16px;
}
.form-wrapper {
  width: 100%;
  padding: 25px 10%;
  .form-wrapper-frame {
    width: 100%;
    padding: 25px;
    margin-bottom: 15px;
    .md-subheading {
      margin-top: 35px;
    }
  }
  @media (max-width: 1200px) {
    padding: 10px 0.5%;
    margin-left: 0;
  }
  .md-layout {
    margin-bottom: 5px;
  }
}
.disclaimer-check {
  margin-top: 20px;
}
.title-icon {
  margin-top: -5px;
}
#submit-btn {
  margin: 25px 0;
  width: 33%;
  padding: 6px;
  font-size: 1.1em;
}
.delete {
  color: #bf1b47 !important;
}
.check-properties {
  font-style: italic;
  color: gray;
  font-weight: 500;
}
.container-info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.icon-info {
  justify-content: center;
  margin: 0 10px 0 0;
  font-size: small;
  background-color: #4ea9dd;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/spa/mediaItem/MediaItemForm.vue